import React from "react";
import ReactSwitch from "react-switch";
import { MyTooltip } from "../tooltip/Tooltip";
import { clx } from "../utils/stringUtils";
import styles from "./Switch.module.scss";
import { useAppSelector } from "@src/store/hooks";
import { Theme } from "@src/store/settingsSlice";
import { ExclamationIcon } from "@src/assets/general-icons/ExclamationIcon";

interface ISwitch {
	checked: boolean;
	onChange: (checked: boolean, event: React.SyntheticEvent<MouseEvent | KeyboardEvent> | MouseEvent, id: string) => void;
	label?: string;
	onColor?: string;
	offColor?: string;
	tooltip?: string;
	tooltipId?: string;
	isDisabled?: boolean;
	labelStyle?: React.CSSProperties;
}

export const Switch: React.FC<ISwitch> = ({
	checked,
	onChange,
	label,
	tooltip,
	tooltipId,
	isDisabled = false,
	onColor,
	offColor,
	labelStyle,
}) => {
	const isLightTheme = useAppSelector((state) => state.settings.theme) === Theme.Light;
	const themedOn = "#FF8E58";
	const themedOff = isLightTheme ? "#cdcdcd" : "#2F2F2F";

	const settings = {
		uncheckedIcon: false,
		height: 14,
		width: 29,
		checkedIcon: false,
		activeBoxShadow: "none",
		handleDiameter: 10,
		onColor: onColor ?? themedOn,
		offColor: offColor ?? themedOff,
		checked,
		onChange,
		disabled: isDisabled,
	};

	const id = (tooltipId ?? tooltip ?? "default").replace(" ", "-") + "switch-id";

	const toggleFromLabel = (event: React.MouseEvent<HTMLDivElement>) => {
		if (isDisabled) return;
		onChange(!checked, event.nativeEvent, id);
	};

	return label ? (
		<div className={clx(styles.main)}>
			<ReactSwitch {...settings} aria-label={label} />
			<div
				aria-hidden="true"
				className={clx({ [styles.label]: true, [styles.active]: checked, [styles.disabled]: isDisabled })}
				style={labelStyle}
				onClick={toggleFromLabel}>
				{label}
			</div>
			{tooltip ? (
				<MyTooltip
					id={id}
					popup={<div style={{ fontSize: "1.2rem" }}>{tooltip}</div>}
					elementStyle={{ display: "flex" }}
					element={
						<div>
							<ExclamationIcon />
						</div>
					}
				/>
			) : null}
		</div>
	) : (
		<ReactSwitch {...settings} />
	);
};
